import React, { useState, useEffect, useContext } from "react";
import "./Add_Money.css";
import { Form, InputGroup } from "react-bootstrap";
import Success_Modal_2 from "../../../../../Common_modal/success_modal2/Success_Modal_2";
import Blue_Btn from "../../../../../Common-Component/common_btn/blue_btn/Blue_Btn";
import { postData } from "../../../../../../utils/api";
import { Context } from "../../../../../../utils/context";

const Add_Money = () => {
  const { getData } = useContext(Context);
  const [amount, setAmount] = useState("");
  const [walletBalance, setWalletBalance] = useState(0);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [razorpayLoaded, setRazorpayLoaded] = useState(false);

  // Fetch wallet balance
  const fetchWalletBalance = async () => {
    try {
      const res = await getData("/wallet/get-balance");
      if (res?.success) {
        setWalletBalance(res.data.balance || 0);
      }
    } catch (err) {
      console.error("Failed to fetch balance", err);
    }
  };

  // Load Razorpay script and detect when it's ready
  useEffect(() => {
    fetchWalletBalance();

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => setRazorpayLoaded(true); // Mark as ready
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
  if (showSuccessModal) {
    const timer = setTimeout(() => {
      setShowSuccessModal(false);
    }, 3000);

    return () => clearTimeout(timer); // cleanup
  }
}, [showSuccessModal]);


  const handleAddMoney = async () => {
    const enteredAmount = Number(amount);
    if (!enteredAmount || enteredAmount <= 0) {
      alert("Please enter a valid amount");
      return;
    }

    if (!razorpayLoaded) {
      alert("Razorpay is still loading, please wait a moment...");
      return;
    }

    setLoading(true);

    try {
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY || "rzp_test_I05KCFb1v5JJRc",
        amount: enteredAmount * 100,
        currency: "INR",
        name: "Mandai",
        description: "Add Money to Wallet",
        image: "/assets/Image/logo.png",
        handler: async (response) => {
          const payload = {
            amount: enteredAmount,
            payment_id: response.razorpay_payment_id,
          };

          const res = await postData("/wallet/add-amount", payload); // Correct endpoint

          if (res?.success) {
            setShowSuccessModal(true);
            fetchWalletBalance();
            setAmount("");
          } else {
            alert(res?.message || "Failed to add money to wallet");
          }
        },
        prefill: {
          name: "User Name",
          email: "user@example.com",
          contact: "9999999999",
        },
        theme: {
          color: "#052c65",
        },
        modal: {
          ondismiss: () => {
            setLoading(false);
            alert("Payment cancelled");
          },
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Razorpay error:", error);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }

    
  };

  const quickAmounts = [500, 1000, 2000, 5000];

  return (
    <section className="Add_Money">
      <div className="available_balance_div">
        <div className="left_side">
          <p className="rupees">₹ {walletBalance}</p>
          <p className="balance">Available Balance</p>
        </div>
        <div className="img_holder">
          <img
            src="/assets/Image/wallet/wallet.png"
            className="img"
            alt="wallet"
          />
        </div>
      </div>

      <div className="gray_holder">
        <div className="form">
          <Form>
            <Form.Group className="input_group">
              <Form.Label>Add Money to Wallet</Form.Label>
              <InputGroup size="sm">
                <InputGroup.Text>₹</InputGroup.Text>
                <Form.Control
                  placeholder="Enter Amount"
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  disabled={loading}
                />
              </InputGroup>
            </Form.Group>

            <div className="row">
              {quickAmounts.map((val) => (
                <div className="col-6" key={val}>
                  <div
                    className={`rs_holder ${amount == val ? "active" : ""}`}
                    onClick={() => setAmount(val.toString())}
                  >
                    <p className="rs_text">₹ {val}</p>
                    {val === 500 && (
                      <div className="absolute_div">
                        <p className="inner_text">Popular</p>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="btn_holder">
              <Blue_Btn
                btn_name={loading ? "Processing..." : "Add Balance"}
                onClick={handleAddMoney}
                disabled={loading || !amount}
              />
            </div>
          </Form>
        </div>
      </div>

      <Success_Modal_2
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        successText={`Amount added successfully to your wallet!`}
      />
    </section>
  );
};

export default Add_Money;
